import { Component, Input, OnInit, ViewChild, AfterViewInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { NotificationMessageService } from 'src/app/shared/notification-message/notification-message.service';
import { UsersService } from 'src/app/users/users.service';
import { DeviceManagementService } from '../device-management.service';
import { DeviceFactory } from 'src/app/home/site-dashboard/device/device-factory/device-factory';
import { TranslateService } from '@ngx-translate/core';
import { CommonService } from 'src/app/shared/services/common.service';
import { DeviceTypeService } from 'src/app/home/site-dashboard/device/device-type.service';

@Component({
	selector: 'app-replace-device',
	templateUrl: './replace-device.component.html',
	styleUrls: ['./replace-device.component.css']
})
export class ReplaceDeviceComponent implements OnInit, AfterViewInit {
	@Input() device;
	@Input() currentSite: any = {};
	@ViewChild("confirmModal") confirmModal;

	deviceLogoClass: string = '';
	nowTime: number = new Date().getTime() / 1000;

	disconnectionLimit: number = 60*60*24*7;
	searchByMacSn: string = '';
	getHitted: boolean = false;
	newDevice: any;
	newDeviceImageLink: string;
	siteID: number;
	customerID: number;
	hasResult: boolean = false;
	searchType: string = 'normal-search';

	constructor(
		private deviceManagementService: DeviceManagementService,
		private notificationMessageService: NotificationMessageService,
		private usersService: UsersService,
		private router: Router,
		private route: ActivatedRoute,
		private translate: TranslateService,
		private commonService: CommonService,
		private deviceTypeService: DeviceTypeService
	) { }

	ngOnInit() {
		if(!this.usersService.hasAccessFunction('replace_device'))
			return this.router.navigate(['/unauthorized']);

		this.siteID = this.route.parent.snapshot.params.siteId || 0;
		this.customerID = this.route.parent.snapshot.params.customerId || 0;
		this.commonService.setPageTabTitle(`${this.currentSite.customer_name} - ${this.currentSite.name} - ${this.device.serial_number} - ${this.translate.instant('admin.replace_device')}`);
	}

	ngAfterViewInit() {
		this.confirmModal.onClose.subscribe((result) => {
			if (result) { // User clicked 'Yes'
				this.executeReplacement();
			}
		});
	}

	getDevice() {
		this.hasResult = false;
		this.newDevice = {};
		const { mac_address, serial_number } = this.device;
		const macSerialObj = this.commonService.adjustMacSearchString(this.searchByMacSn);

		const isSameDeviceUsed = (macSerialObj.mac_address && macSerialObj.mac_address == mac_address) ||
			(macSerialObj.serial_number && macSerialObj.serial_number == serial_number) ||
			macSerialObj == serial_number;

		if (isSameDeviceUsed)
			return this.notificationMessageService.setMessage('translate|replace_device.cannot_use_same_device', {clearOnXTimeNavigate: 1});

		try {
			JSON.parse(this.searchByMacSn);
		} catch (ex) {
			this.searchByMacSn = this.searchByMacSn.trim().replace(/:/g, "");
		}

		let searchBy = 'sn';
		if (/^[a-fA-F0-9]{12}$/.test(this.searchByMacSn))
			searchBy = 'mac';

		if (!this.searchByMacSn)
			return;

		this.deviceManagementService.searchDevices(this.searchByMacSn, searchBy, false, 'no', this.searchType).subscribe((data: any) => {
			this.getHitted = true;
			// let devicePath = [];
			// let sitePath = [];
			let device: any;
			if(data.devices.length) {
				device = data.devices[0];
				if(data.sites && data.sites[device.site_id] && !device.is_deleted) {
					// let customerId = data.sites[device.site_id].customer_id;
					// devicePath = ['/', customerId, device.site_id, device.mac_address, 'performance'];
					// sitePath = ['/', customerId, device.site_id];
					device.site = data.sites[device.site_id];
				}
				this.hasResult = true;
			}
			this.newDevice = device;

			const deviceConfig = DeviceFactory.createDevice(device.sct_device_type);
			this.deviceLogoClass = deviceConfig.config.logoStyleClass;

			if (this.deviceTypeService.isStudyDevice(device))
				this.deviceLogoClass += ' study-logo';

			this.newDeviceImageLink = deviceConfig.getImagePath(device.connected ? "connected" : "not_connected", device);
		});
	}

	confirmReplacement() {
		this.confirmModal.show();
	}

	executeReplacement() {
		this.deviceManagementService.replaceDevice(this.device.mac_address, this.newDevice.mac_address).subscribe((data: any) => {
			if(data.err)
				return this.notificationMessageService.setMessage('globalErrMsg', {clearOnXTimeNavigate: 1});
			this.notificationMessageService.setMessage('globalSuccessMsg');

			this.router.navigate(['/', this.customerID, this.siteID]);
		});
	}
}
